/** Checklist frame chrome. */
export default {
  saveError: "Couldn’t save checklist changes",
  loadingTasks: "Loading tasks",
  gatheringTasks: "Gathering tasks…",
  noTasks: "No tasks yet",
  progress: "{done} of {total} done",
  allDone: "All done",
  addTask: "Add a task",
  task: "Task",
} as const;
